module.exports = __webpack_public_path__ + "img/qfcm-img6.6ee1d4f9.png";